module.exports = __webpack_public_path__ + "assets/Flared Teeth.1e4cd62931d014c916b0e5154b980db6.png";